export function eventPhotoRequirementApplies(photoRequired, onSiteAssignees) {
    return photoRequired && onSiteAssignees.some((assignee) => !assignee.isOwner);
}
//# sourceMappingURL=event-photo-requirement-applies.js.map